var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8,
    cy: 23.8,
    r: 10.05,
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8928 23.8C28.8928 26.6825 28.2591 29.255 27.2718 31.0799C26.2685 32.9345 25.0072 33.85 23.8001 33.85C22.593 33.85 21.3318 32.9345 20.3284 31.0799C19.3412 29.255 18.7075 26.6825 18.7075 23.8C18.7075 20.9175 19.3412 18.345 20.3284 16.5201C21.3318 14.6655 22.593 13.75 23.8001 13.75C25.0072 13.75 26.2685 14.6655 27.2718 16.5201C28.2591 18.345 28.8928 20.9175 28.8928 23.8Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.354 23.9771H34.2458",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7669 16.7457C30.1098 17.8985 27.1612 18.6655 23.7997 18.6655C20.4383 18.6655 17.4896 17.8985 15.8325 16.7457",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 30.8541C17.4903 29.7014 20.4389 28.9344 23.8004 28.9344C27.1618 28.9344 30.1105 29.7014 31.7676 30.8541",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon8);
export default __webpack_public_path__ + "static/media/link-icon-8.da415e4e98a3160c8f233bd07700e197.svg";
export { ForwardRef as ReactComponent };